@if (loading$ | async) {
  <div class="loading-state">
    <nb-spinner></nb-spinner>
  </div>
}

@if (!(loading$ | async) && protocol) {
  <div class="page-container">

    <!-- Sticky header -->
    <div class="sticky-header">
      <button nbButton ghost status="basic" class="back-btn" (click)="navigateBack()">
        <nb-icon icon="arrow-back-outline" pack="eva"></nb-icon>
      </button>

      <div class="header-content">
        <span class="header-title">
          <span class="type-color" [style.background]="protocol.protocolType.color"
                [nbTooltip]="protocol.protocolType.name">{{ protocol.protocolType.shortcut }}</span>
          {{ protocol.protocolType.name }}
        </span>
        <div class="header-badges">
          <wr-building-entity-badge [building]="protocol.building"></wr-building-entity-badge>
          <wr-building-equipment-badge [buildingEquipment]="protocol.buildingEquipment"></wr-building-equipment-badge>
        </div>
      </div>

      <div class="header-actions">
        <button nbButton ghost size="small" nbTooltip="Alle ausklappen" (click)="expandAll()">
          <nb-icon icon="expand-outline" pack="eva"></nb-icon>
        </button>
        <button nbButton ghost size="small" nbTooltip="Alle einklappen" (click)="collapseAll()">
          <nb-icon icon="collapse-outline" pack="eva"></nb-icon>
        </button>
        @if (!isEditing()) {
          <button nbButton ghost size="medium" status="info"
                  [disabled]="pdfDownloading$ | async"
                  (click)="downloadPdf()"
                  nbTooltip="PDF exportieren">
            <nb-icon icon="download-outline" pack="eva"></nb-icon>
          </button>
          @if (canEdit()) {
            <button nbButton ghost size="medium" status="primary"
                    (click)="openShareLinkDialog()"
                    nbTooltip="Protokoll teilen">
              <nb-icon icon="share-outline" pack="eva"></nb-icon>
            </button>
          }
          @if (canPublish()) {
            @if (protocol.status === 'DRAFT') {
              <button nbButton ghost size="medium" status="success"
                      [disabled]="publishing$ | async"
                      (click)="publishProtocol()"
                      nbTooltip="Für externe Mieter veröffentlichen">
                <nb-icon icon="checkmark-circle-2-outline" pack="eva"></nb-icon>
                Veröffentlichen
              </button>
            }
            @if (protocol.status === 'PUBLISHED') {
              <button nbButton ghost size="medium" status="warning"
                      [disabled]="publishing$ | async"
                      (click)="unpublishProtocol()"
                      nbTooltip="Als Entwurf zurückziehen">
                <nb-icon icon="eye-off-outline" pack="eva"></nb-icon>
                Zurückziehen
              </button>
            }
          }
          @if (canEdit()) {
            <button nbButton ghost size="medium" status="primary" (click)="onEdit()"
                    nbTooltip="Bearbeiten">
              <nb-icon icon="edit-outline" pack="eva"></nb-icon>
            </button>
          }
          @if (canDelete()) {
            <button nbButton ghost size="medium" status="danger" (click)="onDelete()"
                    nbTooltip="Löschen">
              <nb-icon icon="trash-2-outline" pack="eva"></nb-icon>
            </button>
          }
        }
        @if (isEditing()) {
          <button nbButton ghost status="basic" size="medium" (click)="cancelEdit()">
            <nb-icon icon="close-outline" pack="eva"></nb-icon>
            Abbrechen
          </button>
          <button nbButton status="primary" size="medium" (click)="submit()" [disabled]="saving$ | async">
            <nb-icon icon="save-outline" pack="eva"></nb-icon>
            Speichern
          </button>
        }
      </div>
    </div>

    <!-- Form sections -->
    <div class="sections">
      @for (section of sections(); track section.instance.id; let i = $index) {
        <div class="section-card">
          <div class="section-header" (click)="toggleExpand(i)"
               [style.background]="getHeaderBg(section.collectionDetail.color)">
            <div class="section-header-left">
              <span class="section-title">{{ section.collectionDetail.title }}</span>
              @if (section.instance.collection.deleted) {
                <nb-icon icon="alert-triangle-outline" pack="eva" status="warning"
                         nbTooltip="Diese Feldgruppe wurde gelöscht" nbTooltipStatus="warning"></nb-icon>
              }
              @if (hasRequiredFields(section)) {
                <span class="required-badge">
                  <nb-icon icon="alert-circle-outline" pack="eva"></nb-icon>
                  Pflichtfelder
                </span>
              }
            </div>
            <nb-icon [icon]="section.expanded ? 'chevron-up-outline' : 'chevron-down-outline'" pack="eva"></nb-icon>
          </div>
          <div class="section-body" [hidden]="!section.expanded">
            @if (section.collectionDetail.description) {
              <p class="description">
                {{ section.collectionDetail.description }}
              </p>
            }
            <wr-custom-form
              [collection]="section.collectionDetail"
              [instance]="section.instance"
              [renderFromInstance]="true"
              [readonly]="!isEditing()">
            </wr-custom-form>
          </div>
        </div>
      }

      @if (sections().length === 0) {
        <div class="empty-state">
          Dieses Protokoll enthält keine Feldgruppen.
        </div>
      }
    </div>

    <!-- Footer: created date + creator -->
    <div class="protocol-footer">
      <span class="created-info">
        <nb-icon icon="calendar-outline" pack="eva"></nb-icon>
        {{ protocol.created | date:'dd.MM.yyyy HH:mm' }}
      </span>
      <nb-user
        size="small"
        [name]="creatorName(protocol)"
        [picture]="getUserProfile(protocol.creator)">
      </nb-user>
    </div>

    <!-- Comments -->
    @if (commentsForm) {
      <nb-card class="comments-card">
        <nb-card-header>
          <div class="comments-header">
            <nb-icon icon="message-circle-outline" pack="eva"></nb-icon>
            <span>Kommentare</span>
          </div>
        </nb-card-header>
        <nb-card-body>
          <wr-comments
            [formGroup]="commentsForm"
            [class.disabled]="!isEditing()">
          </wr-comments>
        </nb-card-body>
      </nb-card>
    }

  </div>
}
